// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3cGDJ","title":"AfterBackImages_title__3HGSF","images":"AfterBackImages_images__HGVTU"};